export default __webpack_public_path__ + "static/media/favicon-nm.2dfbbeb8.ico";